import { mutatorAction } from 'satcheljs';
import PickerPluginViewState from '../schema/PickerPluginViewState';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';

export default mutatorAction(
    'Picker_SetTargetPoint',
    (viewState: PickerPluginViewState, targetPoint: IPoint, bufferZone: number) => {
        viewState.targetPoint = targetPoint;
        viewState.bufferZone = bufferZone;
    }
);
